import { FormField } from '@/shared/ui/form/form-field';
import { ChangeEvent } from 'react';

interface CardNumberFieldProps {
  input: {
    value: string;
    onChange: (value: string) => void;
    [key: string]: any;
  };
  [key: string]: any;
}

export const CardNumberField = (props: CardNumberFieldProps) => {
  const { input, ...rest } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const digits = value.replace(/\D/g, '');
    const trimmed = digits.slice(0, 16);

    let formattedValue = '';
    for (let i = 0; i < trimmed.length; i++) {
      if (i > 0 && i % 4 === 0) {
        formattedValue += ' ';
      }
      formattedValue += trimmed[i];
    }

    input.onChange(formattedValue);
  };

  return (
    <FormField
      {...rest}
      input={{
        ...input,
        onChange: handleChange,
        value: input.value || '',
      }}
    />
  );
};
